<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Media Room'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/img_h5/蒙版组 7@2x_副本.webp" />
				<div class="msg_box">Media Room</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_el" @click="goAbout">
					<img class="bg" src="../../assets/img_h5/蒙版组 10@2x.webp" />
					<div class="tit">
						About CorDx
						<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
					<div class="txt">
						CorDx is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the United States and around the world. Learn more here.
					</div>
				</div>
				<div class="block_2_el">
					<a href="https://cordx.com/uploads/cordx_logo-pack_rev20220525.zip" target="_blank">
						<img class="bg" src="../../assets/img_h5/蒙版组 10@2x (1).webp" />
						<div class="tit">
							Official CorDx Imagery
							<img src="../../assets/img_h5/组 32@2x.png" />
						​</div>
						<div class="txt">
							CorDx is built on accuracy, reliability, and innovation. We’re proud of our brand. Download official CorDx logos and imagery here (for non-commercial use only).
						</div>
					</a>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Press Releases</div>
				<div class="news_box">
					<div class="icon_left animate__animated animate__fadeInLeft" @click="bannerLeftClick">
						<van-icon name="arrow-left" color="#ffffff" size="21px" />
					</div>
					<div class="icon_right animate__animated animate__fadeInRight" @click="bannerRightClick">
						<van-icon name="arrow" color="#ffffff" size="21px" />
					</div>
					<van-swipe class="my-swipe" :show-indicators="true" :loop="true" :autoplay="3000" indicator-color="#0B318F" ref="swipeDom2" :stop-propagation="false">
						<van-swipe-item v-for="(value, index) in newsData" :key="index">
							<div class="swiper_el" @click="goResourcesInfo(value)">
								<img class="bg" :src="value.image" />
								<div class="txt_box">
									<div class="tit">{{ value.title }}</div>
									<div class="time">{{ value.fabu_time }}</div>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<div class="btn_box_f">
					<div class="btn_box_ty btn_box" @click="goResources">
						View More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="title">Contact Us</div>
				<div class="text">
					CorDx welcomes queries from professionals in the media and communications industry. Contact us via the form—we'll respond to you soon!
				</div>
				<img class="bg" src="../../assets/img_h5/蒙版组 1@2x (2).webp" />
				<contact titleText="Submit"></contact>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact.vue'  //联系我们
import { resourcesList } from '@/api/public_h5';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			newsData: [],
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//document.title = 'Media Room - CorDx';
	},
	mounted() {
		let that = this;
		resourcesList({
			catid: 2,
			page: 1,
			page_size: 3,
			language: sessionStorage.getItem('lang'),
		}).then(res2 => {
			that.newsData = res2.data.data;
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		bannerLeftClick(value) {  //导航左侧按钮点击
			let that = this;
			that.$refs.swipeDom2.prev();
		},
		bannerRightClick(value) {  //导航右侧按钮点击
			let that = this;
			that.$refs.swipeDom2.next();
		},
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			//that.$router.push({ path: '/resources-info', query: { id: value.unionid, } });
			that.$router.push({ name: 'Resourcesinfo', params: { resourcesInfoId: value.custom, } });
		},
		goAbout() {
			this.$router.push({ path: '/about' });
		},
		goResources() {
			this.$router.push({ path: '/resources' });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块4*/
	.block_4{
		padding: 42px 20px 64px 20px;
		background-image: linear-gradient(180deg, #F1ECE6 20%, #FFFFFF 100%);
		img.bg{
			width: 100%;
			margin-bottom: 42px;
		}
		.text{
			padding: 20px 0;
			font-size: 20px;
		}
		.title{
			font-size: 42px;
		}
	}
	/*块3*/
	.block_3{
		padding: 42px 20px 120px 20px;
		//background-image: linear-gradient(180deg, #F1ECE6 20%, #FFFFFF 100%);
		.btn_box{
			margin: 42px 0 0 0;
		}
		.news_box{
			.swiper_el{
				padding-bottom: 25px;
				background-color: #FFFFFF;
				//box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
				.txt_box{
					padding: 20px;
					.time{
						padding-top: 30px;
						font-size: 18px;
						color: #706B69;
					}
					.tit{
						font-size: 22px;
					}
				}
				img.bg{
					width: 100%;
					height: auto;
					object-fit: cover;
				}
			}
		}
		.title{
			padding-bottom: 24px;
			font-size: 42px;
		}
	}
	/*块2*/
	.block_2{
		padding: 42px 20px 50px 20px;
		.block_2_el{
			padding-top: 36px;
			padding-bottom: 34px;
			.txt{
				padding: 0;
				font-size: 20px;
				color: #706B69;
			}
			.tit{
				position: relative;
				padding: 20px 0 16px 0;
				font-size: 24px;
				img{
					width: 21px;
					position: absolute;
					right: 0;
				}
			}
			img.bg{
				width: 100%;
			}
		}
		.title{
			padding-bottom: 64px;
			font-size: 36px;
		}
	}
	/*块1*/
	.block_1{
		position: relative;
		.msg_box{
			position: absolute;
			width: 100%;
			top: 50%;
			z-index: 1;
			transform: translate(0%,-50%);
			color: #000000;
			font-size: 42px;
			text-align: center;
		}
		img.bg{
			width: 100%;
		}
	}
}
</style>
